import { mergeWith as e } from "./mergeWith.js";
import { noop as m } from "../../function/noop.js";
function n(r) {
  for (var _len = arguments.length, o = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    o[_key - 1] = arguments[_key];
  }
  return e.apply(void 0, [r].concat(o, [m]));
}
export { n as merge };